// What a pager shows and whether it may act. While a request is out or has
// failed the rows are gone, so the pager keeps the page it asked for and the
// page count of the last loaded set instead of collapsing to Page 1 of 1.

/**
 * @param {object} input
 * @param {'loading'|'error'|'ready'} input.status
 * @param {number} input.page the requested page
 * @param {number} input.currentPage the requested page, clamped to the loaded set
 * @param {number} input.total matching rows in the loaded set
 * @param {number} input.pageSize
 * @param {number} input.knownTotal matching rows the last time the set loaded
 * @returns {{pages: number, current: number, blocked: boolean, busy: boolean}}
 */
export const pagerModel = ({
  status,
  page,
  currentPage,
  total,
  pageSize,
  knownTotal,
}) => {
  if (status === 'ready') {
    const pages = Math.max(1, Math.ceil(total / pageSize))
    return { pages, current: currentPage, blocked: false, busy: false }
  }
  const pages = Math.max(1, Math.ceil(knownTotal / pageSize), page)
  return {
    pages,
    current: Math.max(1, Math.min(page, pages)),
    blocked: true,
    busy: status === 'loading',
  }
}

/**
 * A selection that belongs to the visible page ends when the page changes; a
 * selection of every matching row outlives it.
 * @param {import('../types').SelectionState} [selection]
 */
export const pageScopedSelection = selection =>
  Boolean(selection) && ['rows', 'page'].includes(selection.scope)
